/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Typography, Typography2, useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import imgixParams from 'bundles/page/common/imgixParams';
import OfferingLink2 from 'bundles/unified-home-common/components/consumer/notifications/OfferingLink2';

const styles = {
  offeringCard: (theme: Theme) => css`
    display: block;
    position: relative;

    .offering-content {
      background-color: white;
      border: 1px solid #dcdcdc;
      margin-bottom: 10px;
      min-height: 120px;
      padding: 10px;
      position: relative;
      cursor: pointer;
      overflow: hidden;

      &:hover {
        background-color: #f7f7f7;
      }

      .offering-image {
        ${theme.breakpoints.down('sm')} {
          width: 85px;
          height: 85px;
        }
      }

      .offering-info {
        margin: 0 30px;

        h3 {
          font-size: 20px;
          line-height: 24px;
          margin: 8px 0;
        }

        ${theme.breakpoints.down('xs')} {
          margin-left: 10px;
          margin-bottom: 0;

          h3 {
            margin-top: 0;
          }

          .horizontal-box {
            display: block;
          }
        }
      }
    }
  `,
};

type Props = {
  offering: {
    link: string;
    name: string;
    subtitle: string;
    iconSrc: string;
    id: string;
  };
  disableLocalRouting?: boolean;
};

const DegreeOfferingCard = ({ offering, disableLocalRouting }: Props) => {
  const theme = useTheme();
  return (
    <OfferingLink2
      className="nostyle"
      css={styles.offeringCard(theme)}
      name="offering_card"
      offering={offering}
      disableLocalRouting={disableLocalRouting}
    >
      <div className="offering-content">
        <div className="horizontal-box">
          <div>
            <Imgix
              className="offering-image"
              src={offering.iconSrc}
              imgParams={imgixParams.scale}
              maxWidth={100}
              maxHeight={100}
              alt={Imgix.DECORATIVE}
            />
          </div>
          <div className="offering-info flex-1">
            <div className="horizontal-box">
              <Typography variant="h2" component="h3" className="flex-1">
                {offering.name}
              </Typography>
            </div>
            <div>
              <Typography2 component="p" variant="bodySecondary">
                {offering.subtitle}
              </Typography2>
            </div>
          </div>
        </div>
      </div>
    </OfferingLink2>
  );
};

export default DegreeOfferingCard;
